import { SignUp } from "auth";
import { NextPage } from "next";
import { NextSeo } from "next-seo";
import { useEffect } from "react";
import { sendSignUpPageViewEvent } from "tag-manager";

const SignUpPage: NextPage = () => {
	useEffect(() => {
		sendSignUpPageViewEvent();
	}, []);

	return (
		<>
			<NextSeo
				title="Mango GIS - Sign up"
				description="Start mapping for free with our no-obligation free trial."
				canonical="https://mangomap.com/sign-up"
				openGraph={{
					title: "Mango GIS - Sign up",
					description:
						"Start mapping for free with our no-obligation free trial.",
					url: "https://mangomap.com/sign-up",
					site_name: "Mango GIS",
				}}
			/>
			<SignUp />
		</>
	);
};

export default SignUpPage;
